// Cashback ESPECIAL por etiqueta (17-oct-2026, Cenizas del Sol). Espejo del cálculo del servidor
// (lealify-base lib/loyalty.js): quien tenga la etiqueta gana el MAYOR entre el % especial y el que
// ya le tocaba (general o sucursal). Aquí solo se usa para VISTAS PREVIAS y para la gestión manual
// de puntos; en el check-in real manda el servidor.

/** Etiqueta comparable: sin mayúsculas, sin espacios a los lados, espacios internos = guion bajo. */
export const normTag = (t: string | null | undefined): string =>
  String(t ?? '').trim().toLowerCase().replace(/\s+/g, '_');

interface CfgEspecial { cashbackSpecialTag?: string | null; cashbackSpecialPercentage?: number | null }

/** % que aplica a un cliente con estas etiquetas, partiendo del % base (general o de la sucursal). */
export function pctCashbackCliente(cfg: CfgEspecial | null | undefined, tags: string[] | null | undefined, basePct: number):
  { pct: number; especial: boolean } {
  const tag = normTag(cfg?.cashbackSpecialTag);
  const sp = cfg?.cashbackSpecialPercentage;
  if (!tag || sp == null || !Number.isFinite(Number(sp))) return { pct: basePct, especial: false };
  const tiene = (tags || []).some((t) => normTag(t) === tag);
  return tiene && Number(sp) > basePct ? { pct: Number(sp), especial: true } : { pct: basePct, especial: false };
}
